import { render, staticRenderFns } from "./Lilian.vue?vue&type=template&id=6289dff0&scoped=true&"
import script from "./Lilian.vue?vue&type=script&lang=js&"
export * from "./Lilian.vue?vue&type=script&lang=js&"
import style0 from "./Lilian.vue?vue&type=style&index=0&id=6289dff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6289dff0",
  null
  
)

export default component.exports